import type { FormEvent, ComponentProps } from "react";
import { Search } from "lucide-react";
import { useRouter } from "next/navigation";
import { cn } from "@/lib/utils";

type SearchFormProps = {
  onFocus?: () => void;
  onBlur?: () => void;
  fullWidth?: boolean;
  glassmorphism?: boolean;
} & ComponentProps<"form">;

const SearchForm = ({
  onFocus,
  onBlur,
  fullWidth = false,
  glassmorphism = false,
  ...rest
}: SearchFormProps) => {
  const router = useRouter();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const queryTerm = formData.get("query");
    router.push("/search?q=" + queryTerm);
  };

  return (
    <form
      method="get"
      action="/search"
      onSubmit={handleSubmit}
      className={cn("relative", rest.className)}
    >
      <input
        type="search"
        name="query"
        placeholder="Suchen"
        className={cn(
          "text-input h-[46px] rounded-full transition-all duration-300 ease-in-out placeholder:text-gray-60",
          "[color:hsl(240deg_4%_5%)]",
          glassmorphism
            ? "w-full pl-10 pr-3 py-3 bg-white shadow-md border-0 placeholder:opacity-100"
            : [
                "pl-10 md:pl-8 md:pr-2 py-3 w-[46px] md:w-full min-w-[46px] border border-transparent",
                "focus:w-[200px] md:focus:w-full",
                "placeholder:opacity-0 focus:placeholder:opacity-100 md:placeholder:opacity-100",
                fullWidth && "w-full focus:w-full placeholder:opacity-100",
              ]
        )}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <Search className="absolute left-[15px] md:left-2 top-1/2 transform -translate-y-1/2 text-black w-4 h-4 pointer-events-none" />
    </form>
  );
};

export { SearchForm };
